//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import {
  IMaterializedTweetWithMetrics,
  ITwitterDailyEngagementMetric,
  ITwitterEngagementSummaryStats,
  TwitterMetricSortKey,
} from '@apis/twitter-analytics/twitterAnalyticsApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';

// Type of both stats should be coming from the API code-gen
export interface ITwitterEngagementPageState {
  dateRange: IAliasedDateRange;
  dailyStats: ITwitterDailyEngagementMetric[];
  summaryStats?: ITwitterEngagementSummaryStats;
  topTweets: {
    sortKey: TwitterMetricSortKey;
    view: TwitterTopTweetView;
    offset: number;
    limit: number;
    total: number;
    tweets: IMaterializedTweetWithMetrics[];
  };
  flags: {
    isFetchingDailyStats: boolean;
    isFetchingSummaryStats: boolean;
    isFetchingTopTweets: boolean;
  };
  errors: {
    fetchDailyStatsError?: string;
    fetchSummaryStatsError?: string;
    fetchTopTweetsError?: string;
  };
}

export enum TwitterTopTweetView {
  TableView = 'table',
  GridView = 'grid',
}
